import useFetch from '@hooks/useFetch';
import { emptyObject } from '@constants/empty';

export const getKey = (courseUID) =>
  `sheldon/v1/user/collection-info?collection_uid=${courseUID}`;

const useUserCollectionInfo = (courseUID: string, isSubscribed: boolean) => {
  const key = getKey(courseUID);

  const {
    data: userCollectionInfo,
    isValidating,
    mutate,
    ...rest
  } = useFetch(isSubscribed ? key : undefined, {});

  return {
    key,
    userCollectionInfo: userCollectionInfo || emptyObject,
    isValidating,
    ...rest
  };
};

export default useUserCollectionInfo;
